import { useEffect } from 'react';
import { useAppSelector } from '@/store/hooks';
import { constructPageTitle } from 'common/utils/pages';
import { RootState } from '@/store';
import useRouter from 'use-react-router';

type PageDocumentTitleProps = {
  documentTitle:
    | string
    | ((
        state: RootState,
        props: { location: ReturnType<typeof useRouter>['location']; match?: Record<string, any> }
      ) => string | undefined);
};

const PageDocumentTitle = ({ documentTitle }: PageDocumentTitleProps) => {
  const { location, match } = useRouter();

  const title = useAppSelector(state =>
    typeof documentTitle === 'function' ? documentTitle(state, { location, match }) : documentTitle
  );

  useEffect(() => {
    document.title = constructPageTitle(title);
  }, [title]);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (documentTitle === undefined && import.meta.env.MODE === `development`) {
    throw new Error('The documentTitle is required in route. Check src/routing/index.js for more.');
  }

  return null;
};

export default PageDocumentTitle;
